import { ApolloError } from '@apollo/client';

const NOT_AUTHORIZED_MESSAGES = new Set(['Unauthorized', 'Forbidden']);
const NOT_AUTHORIZED_CODES = new Set(['UNAUTHENTICATED', 'FORBIDDEN']);

/**
 * Returns true when an Apollo/GraphQL error represents permission denial or
 * unauthenticated access (legacy Unauthorized message or Forbidden / FORBIDDEN).
 */
export function isNotAuthorizedError(error?: ApolloError | null): boolean {
  if (!error) {
    return false;
  }
  if (NOT_AUTHORIZED_MESSAGES.has(error.message)) {
    return true;
  }
  return (
    error.graphQLErrors?.some((graphQlError) => {
      const code = graphQlError.extensions?.code;
      return (
        NOT_AUTHORIZED_MESSAGES.has(graphQlError.message) ||
        (typeof code === 'string' && NOT_AUTHORIZED_CODES.has(code))
      );
    }) ?? false
  );
}

/**
 * Returns true when a bare error message string indicates not-authorized.
 */
export function isNotAuthorizedMessage(message?: string | null): boolean {
  return message != null && NOT_AUTHORIZED_MESSAGES.has(message);
}
